import { api } from './client';

export interface AdminUser {
  user_id: string;
  email: string;
  display_name: string;
  avatar_url?: string;
  role: string;
  created_at: string;
}

export const adminApi = {
  listUsers: () =>
    api.get<AdminUser[]>('/admin/users'),

  approveUser: (id: string) =>
    api.patch(`/admin/users/${id}/approve`),

  rejectUser: (id: string) =>
    api.patch(`/admin/users/${id}/reject`),

  deleteUser: (id: string) =>
    api.delete(`/admin/users/${id}`),

  systemInfo: () =>
    api.get<{
      host: {
        cpus: number;
        cpu_model: string;
        cpu_usage_percent: number;
        load_avg_1m: number;
        load_avg_5m: number;
        load_avg_15m: number;
        total_memory_mb: number;
        used_memory_mb: number;
        free_memory_mb: number;
        memory_usage_percent: number;
        uptime_seconds: number;
      };
      process: {
        pid: number;
        uptime_seconds: number;
        heap_used_mb: number;
        heap_total_mb: number;
        rss_mb: number;
      };
      queue: {
        active_workers: number;
        max_workers: number;
        pending_tasks: number;
        processing_tasks: number;
      };
    }>('/admin/system-info'),

  getWorkerConfig: () =>
    api.get<{ max_workers: number }>('/admin/worker-config'),

  updateWorkerConfig: (max_workers: number) =>
    api.patch<{ max_workers: number }>('/admin/worker-config', { max_workers }),

  // SERP Advanced Settings (v0.17.0)
  getSerpSettings: () =>
    api.get<SerpSettingItem[]>('/admin/serp-settings'),

  updateSerpSettings: (settings: Array<{ key: string; value: unknown }>) =>
    api.put<{ updated: number; settings: SerpSettingItem[] }>('/admin/serp-settings', { settings }),
};

export interface SerpSettingItem {
  id: number;
  setting_key: string;
  setting_value: unknown;
  description: string | null;
  updated_by: string;
  updated_at: string;
}
